<template>
    <div>
        <!-- 最新文章讯息 ,该列表最多显示5条信息-->
        <div class="news">
            <div class="newsTitle flex-between">
                <div class="flex-start">
                    <div>{{$t('lastNews')}}</div>
                    <img src="../static/img/home/New.png" alt="news" />
                </div>
                <router-link to="/more" class="color38 fz59">{{$t('more')}}</router-link>
            </div>
            <div class="newsContent">
                <router-link
                    :to="'/articleDetail?name=experience&id='+item.id+'&title='+$t('lastNews')"
                    v-for="(item,index) in studyList"
                    :key="index"
                    class="contenItem flex-between"
                    v-bind:class="{ 'contenItemDeep': index%2}"
                >
                    <p class="oneLine">{{item.news_title}}</p>
                    <time class="fz59">{{item.data}}</time>
                </router-link>
            </div>
        </div>
        <!-- 最新活动讯息 -->
        <div class="news">
            <div class="newsTitle flex-between">
                <div class="flex-start">
                    <div>{{$t('lastArticleNews')}}</div>
                    <img src="../static/img/home/New.png" alt="news" />
                </div>
                <router-link to="/information" class="color38 fz59">{{$t('more')}}</router-link>
            </div>
            <div class="newsContent">
                <router-link
                    :to="'/articleDetail?name=information&id='+item.id+'&title='+$t('lastArticleNews')"
                    v-for="(item,index) in activityList"
                    :key="index"
                    class="contenItem flex-between"
                    v-bind:class="{ 'contenItemDeep': index%2}"
                >
                    <p class="oneLine">{{item.news_title}}</p>
                    <time class="fz59">{{item.data}}</time>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { getTimeBeforeDay } from "../common/js/common";
export default {
    name: "HelloWorld",
    props: ['study','activity'],
    watch:{
        study(res){
            //最多显示5条数据
            if(Array.isArray(res)){
                if(res.length>5){
                    res = res.slice(0,5);
                }
                // this.studyList = getTimeBeforeDay(res,'data');
                this.studyList = res;
            }
            
        },
         //最多显示5条数据
        activity(res){
            if(Array.isArray(res)){
                if(res.length>5){
                    res = res.slice(0,5);
                }
                // this.activityList = getTimeBeforeDay(res,'data');
                this.activityList = res;
            }
            
        }
    },
    data(){
        return {
            studyList:[{}],
            activityList:[{}]
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.news {
    font-size: 0.8rem;
    /* font-size: 0.9rem; */
}
.newsTitle {
    padding: 0.64rem;
    height: 1.2rem;
    background-color: #fff;
    color: #3890d7;
    line-height: 1.2rem;
    font-size: 0.85rem;
    font-weight: 600;
}
.newsTitle img {
    width: 1.65rem;
    margin-left: 0.4rem;
    margin-top: -0.2rem;
}
.newsContent {
    background-color: #dcd0d4;
    padding-top: 0.37rem;
}
.newsContent p {
    width: 14rem;
    text-align: left;
}
.contenItem {
    background-color: #fff;
    height: 1.92rem;
    line-height: 1.92rem;
    padding-left: 0.64rem;
    padding-right: 0.64rem;
    color: #333;
    /* font-size: 0.9rem; */
    font-size: 0.85rem;
}

.newsContent a {
    text-decoration: none;
}
time {
    color: #999;
}
.contenItemDeep {
    background-color: #f4f3ee;
}
.fz59 {
    font-size: 0.59rem;
}
</style>